import { Modal } from '@doordash/component-modal'
import { Colors, Inset, Spacing } from '@doordash/design-language'
import * as React from 'react'
import styled from 'styled-components'
import { OnboardingComponentProps } from '../workflow-components'
import ListCell from '@doordash/component-list-cell'

export const DocumentListCell = styled(ListCell).attrs({
  size: ListCell.Sizes.Small,
  insetSize: ListCell.InsetSizes.XSmall,
})``

const LegalModalDocumentStyle = styled.div`
  background-color: ${Colors.PageBackgroundSecondary};
  overflow-y: scroll;
  border: 1px solid ${Colors.BorderSecondary};
  border-radius: ${Spacing.XxxSmall}px;
`

export const LegalDocumentModalComponent: React.FC<OnboardingComponentProps> = React.memo(
  ({ title, children }) => {
    const [modal, showModal] = React.useState(false)
    return (
      <React.Fragment>
        <DocumentListCell
          onClick={e => {
            showModal(true)
            e.preventDefault()
          }}
          title={title}
        />
        {modal && (
          <Modal
            onClose={() => {
              showModal(false)
            }}
            title={title}
            size={Modal.Sizes.Large}
            hasContentPadding
            ariaHideApp={false}
          >
            <LegalModalDocumentStyle>
              <Inset>{children}</Inset>
            </LegalModalDocumentStyle>
          </Modal>
        )}
      </React.Fragment>
    )
  }
)
